const API_BASE_URL = "https://a0509e1c3b2f.ngrok.io/";

export { API_BASE_URL };
